import { SuggestionData } from "@/common/types/highlightTextArea.type"
import { BillingBillsDescriptionTokenData } from "../types/billingBillsDescriptionTokens.type"

export class BillingBillsDescriptionTokensTransformer {

  static suggestionsTransformer(): (descriptionTokens: BillingBillsDescriptionTokenData[]) => SuggestionData[] {
    return (descriptionTokens) => {
      return descriptionTokens.map((descriptionToken) => {
        return {
          value: descriptionToken.name.startsWith('@') ? descriptionToken.name.slice(1) : descriptionToken.name,
          label: descriptionToken.name.startsWith('@') ? descriptionToken.name.slice(1) : descriptionToken.name,
          description: descriptionToken.description,
          example: descriptionToken.example,
        }
      })
    }
  }

}
